import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as utils from '../store/user/utils';
import { endpoint } from '../pages';

const isAdminUser = <T extends Record<string, never>>(WrappedComponent: React.ComponentType<T>) => {
    const HOCComponent = (props: T) => {
        const navigate = useNavigate();
        const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);

        useEffect(() => {
            if (utils.isAdminUser()) {
                setIsAuthorized(true);
            } else {
                setIsAuthorized(false);
                navigate(endpoint.home);
            }
        }, [navigate]);

        if (!isAuthorized) {
            return null;
        }

        return <WrappedComponent {...props} />;
    };

    HOCComponent.displayName = `isAdminUser(${WrappedComponent.displayName || WrappedComponent.name})`;

    return HOCComponent;
};

export default isAdminUser;
